import React, { useCallback } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core';
import { AlarmIcon } from 'components/Icons';
import { useDisableSubscriptionTransferToWardMutation } from 'schema/serverTypes';
import { MutableButton } from 'ui/MutableButton';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      color: theme.palette.error.main,
      borderColor: theme.palette.error.main,
      '&:hover': {
        borderColor: theme.palette.error.main,
      },
      marginRight: theme.spacing(1),
    },
  })
);

export const DisableSubscriptionTransferButton = (props: { id: string }) => {
  const classes = useStyles();
  const { id } = props;
  const [
    disableSubscriptionTransferToWard,
    { loading },
  ] = useDisableSubscriptionTransferToWardMutation({
    variables: {
      input: {
        wardId: id,
      },
    },
  });
  const onClick = useCallback(async () => {
    await disableSubscriptionTransferToWard();
  }, [disableSubscriptionTransferToWard]);

  return (
    <MutableButton
      loading={loading}
      className={classes.button}
      variant="outlined"
      startIcon={<AlarmIcon />}
      onClick={onClick}
    >
      Запретить перенос подписок
    </MutableButton>
  );
};
